export default __webpack_public_path__ + "static/media/flower_img_top_schedule_2.5c1236f3.webp";